import { render, staticRenderFns } from "./shelves.vue?vue&type=template&id=19cb0af8&"
import script from "./shelves.vue?vue&type=script&lang=js&"
export * from "./shelves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports